module.exports = __webpack_public_path__ + "img/yuanquzhaoshang.335d1a32.png";